import * as React from "react";

export type IAddressInstallationStandard =
  | "stdAir"
  | "nonStdAir"
  | "stdGround"
  | "nonStdGround"
  | "notDefined"
  | null;

interface IAddress {
  street?: string;
  streetNumber: string;
  municipality: string;
  apartmentNumber?: string;
  owner: string;
  isSfh: boolean;
  installationStandard: IAddressInstallationStandard;
  maxSpeed: number;
}

export interface IDecodedToken {
  address: IAddress;
  limited: boolean;
  preferred_username: string;
  name: string;
}

export function useDecodedToken(
  token: string | null | undefined,
): IDecodedToken | undefined {
  return React.useMemo(() => {
    return decodeToken(token);
  }, [token]);
}

export function decodeToken(
  token: string | null | undefined,
): IDecodedToken | undefined {
  if (!token) {
    return;
  }

  try {
    return JSON.parse(
      Buffer.from(token.split(".")[1], "base64").toString("utf8"),
    );
  } catch {
    return;
  }
}
